<template>
  <div id="app">
    <component :is="layout || 'div'">
      <router-view />
    </component>

    <CToaster
      placement="bottom-end"
      class="p-3"
    >
      <CToast
        v-if="updateExists"
        :key="'updateAppToast'"
        :visible="updateExists"
        :autohide="false"
      >
        <CToastBody>
          <h5 class="mb-3">
            An update is available
          </h5>
          <CButton
            color="success"
            variant="outline"
            size="sm"
            @click="refreshApp"
          >
            Update
          </CButton>
        </CToastBody>
      </CToast>
    </CToaster>
  </div>
</template>

<script>
import { mapState } from 'pinia'
import updateAppMixin from './mixins/update-app-mixin'
import { useAppStore } from '@/stores/app.store'

export default {
  name: 'App',

  mixins: [updateAppMixin],

  computed: {
    ...mapState(useAppStore, ['darkMode']),

    layout() {
      return this.$route.matched.find(m => !!m.meta.layout)?.meta?.layout
    }
  },

  watch: {
    // The layouts theme only their own subtree, so <body> kept the light background: it showed through the gaps
    // around the content in dark mode, and teleported modals and toasts stayed light. Theme the whole document
    darkMode: {
      handler(darkMode) {
        document.documentElement.setAttribute('data-coreui-theme', darkMode ? 'dark' : 'light')
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss">
// Import Main styles for this application
@use 'assets/scss/style';
</style>
